/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DashboardGraphLayout } from '../models/DashboardGraphLayout';

export class DashboardGraph {
  /**
  * The unique identifier of the graph
  */
  'id': string;
  /**
  * The ID of the dashboard this graph belongs to
  */
  'dashboardId': string;
  /**
  * The title of the graph
  */
  'title': string;
  /**
  * The chart visualization type
  */
  'chartType': DashboardGraphChartTypeEnum;
  /**
  * The SQL query that provides data for the graph
  */
  'sqlQuery': string;
  /**
  * Mapping of chart axes to query result columns
  */
  'columnMapping': { [key: string]: any; };
  'layout': DashboardGraphLayout;
  /**
  * The timestamp when the graph was created
  */
  'createdAt': Date;
  /**
  * The timestamp when the graph was last updated
  */
  'updatedAt'?: Date | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "dashboardId",
      "baseName": "dashboardId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "title",
      "baseName": "title",
      "type": "string",
      "format": ""
    },
    {
      "name": "chartType",
      "baseName": "chartType",
      "type": "DashboardGraphChartTypeEnum",
      "format": ""
    },
    {
      "name": "sqlQuery",
      "baseName": "sqlQuery",
      "type": "string",
      "format": ""
    },
    {
      "name": "columnMapping",
      "baseName": "columnMapping",
      "type": "{ [key: string]: any; }",
      "format": ""
    },
    {
      "name": "layout",
      "baseName": "layout",
      "type": "DashboardGraphLayout",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "updatedAt",
      "baseName": "updatedAt",
      "type": "Date",
      "format": "date-time"
    }  ];

  static getAttributeTypeMap() {
    return DashboardGraph.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum DashboardGraphChartTypeEnum {
  Bar = 'BAR',
  Line = 'LINE',
  Pie = 'PIE',
  Area = 'AREA',
  Scatter = 'SCATTER',
  Donut = 'DONUT',
  Table = 'TABLE'
}

